import types, {baseAsyncTypes} from 'actions/types'
import {createDataBlockReducer} from 'helpers/reducer'
import {combineReducers} from 'redux'
import {findIndex, map, has, isNil} from 'lodash'
import Immutable from 'seamless-immutable'
import {createPivotTableReducer} from 'reducers/pivotTable'

const defaultFilters = {
  showDormants: false,
}

export const createContactsDataBlock = (baseAction) => {
  const attemptAction = baseAction + '_ATTEMPT'
  const successAction = baseAction + '_SUCCESS'
  const failureAction = baseAction + '_FAILURE'

  return createDataBlockReducer(baseAction, {
    index: (state = Immutable(0), action) => {
      switch (action.type) {
        case successAction:
          if (action.index != null) {
            return action.index
          } else {
            return state
          }
        default:
          return state
      }
    },
    topLoading: (state = Immutable(false), action) => {
      switch (action.type) {
        case attemptAction:
          return (action.topLoading !== null && action.topLoading === true)
        case successAction:
        case failureAction:
          return false
        default:
          return state
      }
    },
    bottomLoading: (state = Immutable(false), action) => {
      switch (action.type) {
        case attemptAction:
          return (action.bottomLoading !== null && action.bottomLoading === true)
        case successAction:
        case failureAction:
          return false
        default:
          return state
      }
    },
  }, false)()
}

export const drawerOpen = (state = Immutable(false), action) => {
  switch (action.type) {
    case types.CONTACTS_TOGGLE_SEARCH_DRAWER:
      return isNil(action.toggle)
          ? !state
          : action.toggle
    default:
      return state
  }
}

const defaultSelectedList = {name: 'All contacts', id: 0}

const selectedList = (state = defaultSelectedList, action) => {
  switch (action.type) {
    case types.CONTACTS_SET_CONTACT_LIST:
      return {
        name: action.listName,
        id: action.listId,
      }
    case types.CONTACT_LISTS_DELETE_LIST_SUCCESS:
      return action.list.id === state.id
          ? defaultSelectedList
          : state
    case types.CONTACT_LISTS_UPDATE_LIST_SUCCESS:
      return action.data.id === state.id
          ? {
            ...state,
            name: action.data.name,
          }
          : state
    default:
      return state
  }
}

const lists = (state = Immutable({}), action) => {
  switch (action.type) {
    case types.CONTACTS_LOAD_CONTACT_LISTS_SUCCESS:
      const newState = {...state}
      map(action.data, (list) => {
        const {categoryId} = list
        if (!has(newState, categoryId)) {
          newState[categoryId] = [list]
        } else {
          const idx = findIndex(newState[categoryId], ['id', list.id])
          if (idx > -1) {
            newState[categoryId][idx] = list
          } else {
            newState[categoryId].push(list)
          }

        }
      })
      return newState
    default:
      return state
  }
}

const folders = (state = Immutable({}), action) => {
  switch (action.type) {
    case types.CONTACTS_LOAD_CONTACT_LIST_CATEGORY_SUCCESS:
      const newState = {...state}
      map(action.data, folder => {
        const parentId = folder.parentId || -1
        if (!has(newState, parentId)) {
          newState[parentId] = [folder]
        } else {
          const idx = findIndex(newState[parentId], ['id', folder.id])
          if (idx > -1) {
            newState[parentId][idx] = folder
          } else {
            newState[parentId].push(folder)
          }
        }
      })
      return newState
    default:
      return state
  }
}

const searched = (state = null, action) => {
  switch (action.type) {
    case types.CONTACTS_SEARCH:
      return action.phrase
    default:
      return state
  }
}

const filters = (state = defaultFilters, action) => {
  switch (action.type) {
    case types.CONTACTS_UPDATE_FILTERS:
      return {...state, ...action.filters}
    default:
      return state
  }
}

export const contactsSearchPivotTableKey = 'contactsContext.search.pivotTable'

export default combineReducers({
  drawerOpen,
  contacts: createContactsDataBlock(baseAsyncTypes.CONTACTS_LOAD_CONTACTS),
  companies: createContactsDataBlock(baseAsyncTypes.CONTACTS_LOAD_COMPANIES),
  pivotTable: createPivotTableReducer({
    key: contactsSearchPivotTableKey,
    defaultSortColumn: 'companyName',
    defaultSortDirection: 'asc',
    pageSize: 50,
  }),
  selectedList,
  lists,
  folders,
  searched,
  filters,
})
